if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.qtyBubble = document.querySelector('.cart-count-bubble');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove(
          'hidden',
        );

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (formData.get('quantity') === '0') {
          // This is the row's OWN submit button, where a quantity of 0 is a
          // default the row was left at, not a customer choice — unlike the
          // bulk-add path (add-multiple-products-table.js), where 0 means
          // "not ordering this row" and must never be raised. Scaling the
          // previous hard-coded '1' to the resolved increment preserves that
          // existing "0 becomes buyable" behaviour for restricted rows too.
          const quantityInput = document.querySelector(
            `[form="${this.form.id}"][name="quantity"]`,
          );
          const salesIncrement = quantityInput
            ? parseInt(quantityInput.dataset.salesIncrement, 10) || 0
            : 0;
          formData.set('quantity', String(salesIncrement > 1 ? salesIncrement : 1));
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.querySelector('.loading-overlay__success').classList.remove(
                'hidden',
              );
              this.form.insertAdjacentHTML(
                'afterend',
                `<div class="cart-success-message twcss-text-pgreen twcss-text-xl twcss-font-medium twcss-items-center twcss-justify-center twcss-flex twcss-h-full twcss-w-full twcss-absolute twcss-inset-y-0 twcss-inset-x-0 twcss-bg-white/75">
                        <span>Lisätty koriin</span>
                    </div>`,
              );

              this.onCartUpdate();
              //window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            setTimeout(() => {
              this.querySelector('.loading-overlay__success').classList.add(
                'hidden',
              );
              this.submitButton.classList.remove('loading');
            }, 1500);

            setTimeout(() => {
              this.querySelector('.cart-success-message').remove();
            }, 1500);

            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add(
              'hidden',
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message',
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
      onCartUpdate() {
        fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              'text/html',
            );
            const sourceQtyBubble = html.querySelector('.cart-count-bubble');

            this.qtyBubble.innerHTML = sourceQtyBubble.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    },
  );
}
